var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-template',[_c('div',{staticClass:"top-area"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataForm.newsTitle))]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.dataForm.publichTime))])]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.dataForm.newsContent))])])
}
var staticRenderFns = []

export { render, staticRenderFns }